
function wizzycheck_Validvalue(selector) {
  if (
    parseInt(selector.value) !== 0 &&
    selector.classList.contains("invalidSelection")
  ) {
    selector.classList.remove("invalidSelection");
  }
}
window.addEventListener('scroll', () => {
    if (window.scrollY > 15) {
      document.body.classList.add('wz-scrolled');
    } else {
      document.body.classList.remove('wz-scrolled');
    }
  });
// window.customAddProductToCart = customAddProductToCart;
var searchIcon =
  window.innerWidth < 768
    ? document.querySelector(".header__primary-nav .header__search-link")
    : document.querySelector(".header__secondary-nav .header__search-link");
var searchInput =
  window.innerWidth < 768
    ? document.querySelector(
        "#search_mini_form .wizzy-search-form .search-query"
      )
    : document.querySelector(
        "#predictive-search-form .header-search__form-control .header-search__input"
      );

// searchIcon.addEventListener("click", () => {
//   setTimeout(() => {
//     if (window.innerWidth < 768) {
//       // document.querySelector(".search-drawer-close").click();
//     }
//     searchInput?.click();
//   }, 500);
// });

searchIcon.addEventListener("click", () => {
  if (window.innerWidth >= 768) {
    const observer = new MutationObserver(() => {
      if (document.documentElement.classList.contains('lock')) {
        document.documentElement.classList.remove('lock');
        console.log("Removed .lock from <html>");
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  searchInput?.click();
});



if (window.innerWidth > 768) {
  searchInput.addEventListener(
    "click",
    () => {
      setTimeout(() => {
        const wizzyBodyWrapper = document.querySelector(
          ".wizzy-body-end-wrapper"
        );
        const wizzyAutocomplete = document.querySelector(
          ".wizzy-autocomplete-wrapper"
        );
        if (wizzyBodyWrapper) {
          wizzyBodyWrapper.addEventListener("click", () => {
            if (wizzyAutocomplete) {
              wizzyAutocomplete.style.display = "none";
            }
          });
        }
      });
    },
    500
  );
}

function checkWizzyConfigAndUpdate() {
  window.wizzyConfig.common.isOnCategoryPage == !0
    ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
        "#wizzy-shopify-collection-page-wrapper",
      ])
    : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
        "#main",
      ]),
    window.wizzyConfig &&
      (window.matchMedia("(max-width: 768px)").matches
        ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#search_mini_form .wizzy-search-form .search-query",
            type: "text",
          })
        : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#predictive-search-form .header-search__form-control .header-search__input",
            type: "search",
          }),
      clearInterval(interval));
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);


const customSortOrderForCollection = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  if (filter.sort[0].field === "relevance") {
    newSort.push(
      // {
      //   field: "product_value_tags_apparel_ruled_based_bt:float",
      //   order: "asc",
      // },
      // {
      //   field: "product_value_tags_yoga_bag_ruled_based_bt:float",
      //   order: "asc",
      // },
      // {
      //   field: "product_value_tags_bandana_ruled_based_bt:float",
      //   order: "asc",
      // },
      // {
      //   field: "product_value_tags_jewellery_ruled_based_bt:float",
      //   order: "asc",
      // },
      {
        field: "product_wizzy-best-selling_sortOrder:float",
        order: "asc",
      },
      {
        field: "product_ksa:float",
        order: "desc",
      },
    );
    
  } else {
    //else make sure that selected sort is applying
    newSort = filter.sort;
  }
  filter.sort.forEach((x) => {
      if (
        // x.field != "product_value_tags_apparel_ruled_based_bt:float" &&
        // x.field != "product_value_tags_yoga_bag_ruled_based_bt:float" &&
        // x.field != "product_value_tags_bandana_ruled_based_bt:float" &&
        // x.field != "product_value_tags_jewellery_ruled_based_bt:float" &&
        x.field != "product_wizzy-best-selling_sortOrder:float" && 
        x.field != "product_ksa:float" && x.field != "product_earthday-wear_sortOrder:float"
      ) {
        newSort.unshift(x);
      }
    });
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
}

window.onWizzyScriptLoaded = function () {
  if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.categoryName === "tb Exclusives")
  {
    document.body.classList.add("ontbExclusive");
  }
  else
  {
    document.body.classList.remove("ontbExclusive");
  }
  if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "tb-exclusives")
  {
    document.body.classList.add("tbExclusive");
  }
  else
  {
    document.body.classList.remove("tbExclusive");
  }
  if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "winter-24")
  {
    document.body.classList.add("winter_24");
  }
  else
  {
    document.body.classList.remove("winter_24");
  }
  function toggleBodyOverflow(isOpen) {
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }
  const headerSearch = document.querySelector('.header-search');
  if (!headerSearch) return;

  // initial state check
  toggleBodyOverflow(headerSearch.hasAttribute('open'));

  const headerobserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        toggleBodyOverflow(headerSearch.hasAttribute('open'));
      }
    });
  });

  headerobserver.observe(headerSearch, {
    attributes: true,
    attributeFilter: ['open']
  });
  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.common.isOnCategoryPage == true
        ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#main",
          ]);
      window.matchMedia("(max-width: 768px)").matches
        ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#search_mini_form .wizzy-search-form .search-query",
            type: "text",
          })
        : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#predictive-search-form .header-search__form-control .header-search__input",
            type: "search",
          });
      // window.wizzyConfig.search.configs.pagination.type = "numbered";
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      // window.wizzyConfig.search.configs.pagination.type = "numbered";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      var dropdowns = document.querySelectorAll(".swatch-dropdown");
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener("change", function () {
          var selectedOption = dropdown.options[dropdown.selectedIndex];
          var selectedSwatchValue = selectedOption.value;
          var currentDropDown = $(this).parent();
          var currentCart = currentDropDown.find("#cartBtnNew");
          currentCart.attr("value", selectedSwatchValue);
          // Buy now
          var currentBuyBtn = currentDropDown.find(".buyBtnNew");
          currentBuyBtn.attr(
            "href",
            "/cart/" + selectedSwatchValue + ":1?checkouts"
          );
        });
      });

      if (wizzyConfig.pageStore.searchSubmitValue) {
        if (wizzyConfig.pageStore.searchSubmitValue.includes("rakhi")) {
          let aspectRatioDivs = document.querySelectorAll(
            ".AspectRatio.AspectRatio--withFallback"
          );
          // console.log(aspectRatioDivs);
          aspectRatioDivs.forEach((div) => {
            div.style.setProperty("--aspect-ratio", "1");
          });
        }
      }

      const validHandles = [
        "rakhi",
        "gold-rakhi",
        "brass-rakhi",
        "kids-rakhi",
        "silver-rakhi",
      ];

      if (validHandles.includes(wizzyConfig.common.collectionHandle)) {
        let aspectRatioDivsNew = document.querySelectorAll(
          ".AspectRatio.AspectRatio--withFallback"
        );
        // console.log(aspectRatioDivsNew);
        aspectRatioDivsNew.forEach((div) => {
          div.style.setProperty("--aspect-ratio", "1");
        });
      }

      if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "new-in-ikat")
      {
        document.body.classList.add('wz-ikat-collection');
      }
      else
      {
        document.body.classList.remove('wz-ikat-collection');
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      var dropdowns = document.querySelectorAll(".swatch-dropdown");
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener("change", function () {
          var selectedOption = dropdown.options[dropdown.selectedIndex];
          var selectedSwatchValue = selectedOption.value;
          var currentDropDown = $(this).parent();
          var currentCart = currentDropDown.find("#cartBtnNew");
          currentCart.attr("value", selectedSwatchValue);
          // Buy now
          var currentBuyBtn = currentDropDown.find(".buyBtnNew");
          currentBuyBtn.attr(
            "href",
            "/cart/" + selectedSwatchValue + ":1?checkouts"
          );
        });
      });

      if (wizzyConfig.pageStore.searchSubmitValue) {
        if (wizzyConfig.pageStore.searchSubmitValue.includes("rakhi")) {
          let aspectRatioDivs = document.querySelectorAll(
            ".AspectRatio.AspectRatio--withFallback"
          );
          // console.log(aspectRatioDivs);
          aspectRatioDivs.forEach((div) => {
            div.style.setProperty("--aspect-ratio", "1");
          });
        }
      }

      const validHandles = [
        "rakhi",
        "gold-rakhi",
        "brass-rakhi",
        "kids-rakhi",
        "silver-rakhi",
      ];

      if (validHandles.includes(wizzyConfig.common.collectionHandle)) {
        let aspectRatioDivsNew = document.querySelectorAll(
          ".AspectRatio.AspectRatio--withFallback"
        );
        // console.log(aspectRatioDivsNew);
        aspectRatioDivsNew.forEach((div) => {
          div.style.setProperty("--aspect-ratio", "1");
        });
      }

      if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "new-in-ikat")
      {
        document.body.classList.add('wz-ikat-collection');
      }
      else
      {
        document.body.classList.remove('wz-ikat-collection');
      }

      return payload;
    }
  );

  

  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (payload) {
        try{
        payload.map((product, index) => {
          let attributes = product.attributes;

          // const tags = attributes
          //   .find((x) => x.id === "product_tags")
          //   ?.values.flatMap((x) => x.value);
          // // let limited_sale = tags !== undefined && tags.length > 0 ? tags[0] : "";
          // // limited_sale = limited_sale
          // //   .split(",")
          // //   .find((tag) => tag.includes("badge_"))
          // //   ?.split("_")[1];
          // // product.tags = limited_sale ? limited_sale : "";

          // let limited_sale_1 =
          //   tags !== undefined && tags.length > 0 ? tags[0] : "";
          // badgeOne = limited_sale_1
          //   .split(",")
          //   .find((tag) => tag.includes("badgeOne_"))
          //   ?.split("_")[1];
          // product.badgeOne = badgeOne ? badgeOne : "";

          // let limited_sale_2 =
          //   tags !== undefined && tags.length > 0 ? tags[0] : "";
          // badgeTwo = limited_sale_2
          //   .split(",")
          //   .find((tag) => tag.includes("badgeTwo_"))
          //   ?.split("_")[1];
          // product.badgeTwo = badgeTwo ? badgeTwo : "";

          // let mainImage = product.mainImage;
          // product.mainImage = product.hoverImage;
          // product.hoverImage = mainImage;

          // preloadImg(product.mainImage, product.hoverImage);

          product.varientId = product.id;
          if (product?.swatches?.length !== 0) {
            product.productHasSwatches = true;
          }
        });

        // const groupIdsToDemote = [
        //   9324695126272,
        //   9324697026816,
        //   9324697649408,
        //   9324414370048,
        //   9324413976832,
        //   9324413026560
        // ];

        // if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "new-drop") {
        //   payload = payload.sort((a, b) => {
        //     // If both objects are in the demote list or both are not, they stay in the same order

        //     const aGroupId = a.groupId ? a.groupId : a.id;
        //     const bGroupId = b.groupId ? b.groupId : b.id;

        //     const aIsDemoted = groupIdsToDemote.includes(aGroupId);
        //     const bIsDemoted = groupIdsToDemote.includes(bGroupId);
            
        //     if (aIsDemoted && !bIsDemoted) {
        //       return 1; // a goes after b
        //     }
        //     if (!aIsDemoted && bIsDemoted) {
        //       return -1; // b goes after a
        //     }
            
        //     return 0; // If both are the same, don't change their order
        //   });
        // }

        }
        catch(e){
          console.log(e);
        }
        return payload;
      }
    );
    let skuArray = ["TB3740",
                    "TB3743",
                    "TB3744",
                    "TB3745",
                    "TB3747",
                    "TB3748",
                    "TB3749",
                    "TB3750",
                    "TB3751",
                    "TB3753",
                    "TB3824",
                    "TB3825",
                    "TB3826",
                    "TB4059",
                    "TB4060",
                    "TB4061",
                    "TB4065",
                    "TB4066",
                    "TB4067",
                    "TB3739", 
                    "TB3752"
                  ];
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        products.forEach((product) => {
          const productSizeSwatch = product.swatches?.find(
            (item) => item.key === "sizes"
          );
          // console.log(productSizeSwatch);
          if (productSizeSwatch && productSizeSwatch.values.length > 0) {
            product.hasFreeSize = productSizeSwatch.values.some(
              (item) => item.value === "Freesize"
            );
          }
          product.attributes.forEach(attr => {
            if(attr.id === "product_tags") {
              if (attr.values[0].value[0].includes("badgeOne_Just In") && window.wizzyConfig.common.collectionHandle !== "black-friday-sale-1") {
                product.badgeJustIn = true;
              }
              if (attr.values[0].value[0].includes("badgeTwo_LUXE")) {
                product.badgeLuxe = true;
              }
              if (attr.values[0].value[0].includes("ikat2026") || attr.values[0].value[0].includes("value2026")) {
                product.new_arrival = true;
              }
              else if (attr.values[0].value[0].includes("trueCore_yes")) {
                product.trueCore = true;
              }
            }
            if(attr.id === "product_sku")
            {
              let code = attr.values[0].value[0].split("-")[0].toUpperCase();;
              if(skuArray.includes(code))
              {
                product.webExTag = true;
              }
            }
          });
          if (product.price) {
            product.price = parseInt(product.price.replace(/,/g, ""), 10);
          }
          if (product.sellingPrice) {
            product.sellingPrice = parseInt(
              product.sellingPrice.replace(/,/g, ""),
              10
            );
          }
        });
        // console.log(products, "<<<<<<<<<<<<<<<<<<<<<products");
        return products;
      }
    );
  const excludeSaleTag = [
    46578752717056,
    47035843969280,
    47035839545600,
    47035983888640,
    47035988148480
  ]
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        if (product.attributes) {
          product.attributes.forEach((atr) => {
            if (atr.id === "product_handle") {
              product.handle = atr.values[0].value[0];
            } else if (atr.id === "product_badge_judgeme") {
              product.review = atr.values[0].value[0];
            } else if (atr.id === "product_value_tags_bfs2025_ruled_based_bt" && atr.values[0].value[0] == 1 && !excludeSaleTag.includes(product.id)) {
              product.bfs2025Tag = true;
            }
          });
        }
      });

      products.forEach((product) => {
        if (
          product.discountPercentage !== null &&
          product.discountPercentage !== undefined &&
          product.discountPercentage !== "" &&
          !Number.isNaN(Number(product.discountPercentage)) &&
          Number(product.discountPercentage) > 0
        ) {
          product.discountPresent = true;
        }
      });

      return products;
    }
  );
  localStorage.setItem("gridValue", "medium");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      const device = window.innerWidth < 768 ? "mobile" : "desktop";

      if(window.wizzyConfig.common.isOnCategoryPage)
      {
        document.body.classList.add('wz-collection');
        document.body.classList.remove('wz-search');
      }
      else
      {
        document.body.classList.remove('wz-collection');
        document.body.classList.add('wz-search');
      }

      const layOutShiftBtns = document.querySelectorAll(
        `collection-layout-switch[device="${device}"] .collection-toolbar__button`
      );

      layOutShiftBtns.forEach((btn) => {
        btn.classList.remove("is-active");
        btn.addEventListener("click", () => {
          const value = btn.getAttribute("value");
          localStorage.setItem("gridValue", value);
        });
      });

      const gridValue = localStorage.getItem("gridValue");
      const currentlayOutBtn = document.querySelector(
        `collection-layout-switch[device="${device}"] .collection-toolbar__button[value="${gridValue}"]`
      );
      if (gridValue && currentlayOutBtn) {
        const searchList = document.querySelector(".wizzy-search-results-list");
        searchList.setAttribute(`collection-${device}-layout`, gridValue);
        if (!currentlayOutBtn.classList.contains("is-active")) {
          currentlayOutBtn.classList.add("is-active");
        }
      }
      setTimeout(function() {
        document.querySelectorAll("#wizzy-dropdown").forEach(dropdown => {
            let firstValid = Array.from(dropdown.options).find(
                opt => !opt.disabled && opt.value !== "0"
            );
            if (firstValid) {
                firstValid.selected = true; // don't trigger change
            }
        });
    }, 500);

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log("BEFORE_AUTOCOMPLETE_EXECUTED", payload);
      payload.includeOutOfStock = "false";
      return payload;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      document.body.classList.add('wizzy-search');
      document.body.classList.remove("ontbExclusive");
      document.body.classList.remove("winter_24");
      document.body.classList.remove("tbExclusive");
      if (window.innerWidth < 768) {
        var searchform = document.querySelector(
          ".wizzy-search-form-wrapper.mf-initial "
        );
        var backBtn = document.querySelector(
          ".wizzy-search-form .wizzy-search-back"
        );
        if (searchform && searchform.classList.contains("mobileTapped")) {
          backBtn.click();
          // searchform.classList.remove("mobileTapped");
        }
      } else {
        const closeBtn = document.querySelector(
          "#predictive-search-form dialog-close-button"
        );

        if (closeBtn) {
          closeBtn.click();
        }
      }

      payload.includeOutOfStock = "false";

      return payload;
    }
  );

  const manualCollections = [
    "workwear",
    "evening",
    "travel",
    "wellness",
    "truecore",
    "bestseller_truecore",
    "all-in-jewelry",
    "winter-24",
    "tb-exclusives",
    "bestsellers-19th-sep",
    "end-of-season-sale",
  ]
  const cottonCollections = [
    "office-wear",
    "saree",
  ]


  const manualCollectionSort = [
    "earthday-apparel",
    "product-under-2499"
  ];

  

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle === "black-friday-sale-1" || window.wizzyConfig.common.collectionHandle === "last-chance-1" ))
      // {
      //   addManualSortingForBFSCollection(payload.filters);
      // } else if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "karwa-chauth-2025") {
      //   addManualCollectionSorting(payload.filters);
      // }
      // if(window.wizzyConfig.common.isOnCategoryPage && cottonCollections.includes(window.wizzyConfig.common.collectionHandle))
      // {
      //   removeRelevance(payload.filters);
      //   addCottonSort(payload.filters);
      // }
      // else if(window.wizzyConfig.common.isOnCategoryPage && manualCollections.includes(window.wizzyConfig.common.collectionHandle))
      // {
      //   removeRelevance(payload.filters);
      // } 
      // else if(window.wizzyConfig.common.isOnCategoryPage && manualCollectionSort.includes(window.wizzyConfig.common.collectionHandle))
      // {
      //   addManualCollectionSorting(payload.filters);
      // }
      // else if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle === "all-in-jewelry"))
      // {
      //   applyNewestFirst(payload.filters);
      // }
      // else if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle === "earthday-wear"))
      // {
      //   customSortOrderForCollection(payload.filters);
      // }
      // else if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle === "rakhi-sale" || window.wizzyConfig.common.collectionHandle === "kurta-sets" || window.wizzyConfig.common.collectionHandle === "co-ords" || window.wizzyConfig.common.collectionHandle === "dress"))
      if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle !== "new-arrival")
      {
        applyKSASort(payload.filters);
        console.log("filters", payload.filters);
      }

      if(window.wizzyConfig.common.isOnCategoryPage && (window.wizzyConfig.common.collectionHandle === "yoga-bags" || window.wizzyConfig.common.collectionHandle === "new-in-ikat"))
      {
        payload.filters.inStock = ["true","false"];
      }
      else
      {
        payload.filters.inStock = ["true"];
      }
      // if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "karwa-chauth-2025")
      // {
      //   addManualCollectionSorting(payload.filters);
      // }
      payload.filters.boostGroupIds = [];

      // payload.filters.inStock = ["true","false"];
      return payload;
    },3
  );

  // Market Implementation - 09-07-2026
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      // console.log("WIZZY BEFORE_SEARCH", data);

      const inventorySources = getMarketInventorySource();

      data.inventorySources = JSON.stringify(inventorySources);

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {

      data.filters.inventorySources = getMarketInventorySource();

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {

      const inventorySources = getMarketInventorySource();

      data.inventorySources = JSON.stringify(inventorySources);

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {

      var products = data.response?.payload?.result;

      // console.log("Wizzy AFTER_WIZZY_API_RESPONDED", products);

      if (products && products.length > 0) {
        products.forEach((product) => {
          if (product.price && typeof product.price === "object") {
            var minPrice = Math.min(
              ...product.price.map((value) => parseFloat(value))
            );
            product.price = minPrice.toFixed(2);
          }

          if (product.sellingPrice && typeof product.sellingPrice === "object") {
            var minSellingPrice = Math.min(
              ...product.sellingPrice.map((value) => parseFloat(value))
            );
            product.sellingPrice = minSellingPrice.toFixed(2);
          }

          if (product.discount && typeof product.discount === "object") {
            var minDiscount = Math.min(
              ...product.discount.map((value) => parseFloat(value))
            );
            product.discount = minDiscount.toFixed(2);
          }

          if (
            product.discountPercentage &&
            typeof product.discountPercentage === "object"
          ) {
            var minDiscountPercentage = Math.min(
              ...product.discountPercentage.map((value) => parseFloat(value))
            );
            product.discountPercentage = minDiscountPercentage.toFixed(2);
          }

          if (product.price && product.sellingPrice) {
            let discount = getFloatVal(
              product.price - product.sellingPrice
            ).toFixed(2);

            if (discount && discount > 0.1) {
              product.discount = discount;
              product.discountPercentage = getFloatVal(
                Math.round(
                  ((product.price - product.sellingPrice) / product.price) * 100
                )
              );
            }
          }

          if (window.Shopify?.country === "US" && product.url) {
            const productUrl = new URL(product.url);

            if (!productUrl.pathname.startsWith("/en-us/")) {
              productUrl.pathname = "/en-us" + productUrl.pathname;
              product.url = productUrl.toString();
            }
          }
        });
      }

      return data;
    }
  );
};

const addCottonSort = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  // if (filter.sort[0].field === "relevance") {
    newSort.push(
      {
        field: "product_value_tags_cotton_tag",
        order: "desc",
      },
      {
        field: "product_ksa:float",
        order: "desc",
      },
    );
    
  // } else {
  //   //else make sure that selected sort is applying
  //   newSort = filter.sort;
  // }
  filter.sort.forEach((x) => {
      if (
        x.field != "product_value_tags_cotton_tag" && 
        x.field != "product_ksa:float"
      ) {
        newSort.push(x);
      }
    });
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};

const applyKSASort = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  // if (filter.sort[0].field === "relevance") {
    newSort.push(
      {
        field: "relevance",
        order: "asc",
      },
      {
        field: "product_ksa:float",
        order: "desc",
      },
    );
    
  // } else {
    //else make sure that selected sort is applying
    // newSort = filter.sort;
  // }
  filter.sort.forEach((x) => {
      if (
        x.field != "product_ksa:float" && 
        x.field != "relevance"
      ) {
        newSort.push(x);
      }
    });
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};

const applyNewestFirst = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  // if (filter.sort[0].field === "relevance") {
    newSort.push(
      {
        field: "gender",
        order: "desc",
      },
      {
        field: "createdAt",
        order: "desc",
      },
    );
    
  // } else {
  //   //else make sure that selected sort is applying
  //   newSort = filter.sort;
  // }
  filter.sort.forEach((x) => {
      if (
        x.field != "createdAt" && 
        x.field != "relevance"
      ) {
        newSort.push(x);
      }
    });
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};
const removeRelevance = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  // if (filter.sort[0].field === "relevance") {
  //   newSort.push(
  //     // {
  //     //   field: "discountPercentage",
  //     //   order: "desc",
  //     // },
  //     {
  //       field: "product_wizzy-best-selling_sortOrder:float",
  //       order: "asc",
  //     },
  //   );
    
  // } else {
  //   //else make sure that selected sort is applying
  //   newSort = filter.sort;
  // }
  filter.sort.forEach((x) => {
      if (
        x.field != "relevance"
      ) {
        newSort.push(x);
      }
    });
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};
function hasToExcludeCollectionFromSorting(collectionHandle) {
  const collectionHandlesToExculde = ["sitara-new-collection","timeless-wedding-styles","new-in","bestsellers-19th-sep", "winter-24"];
  return collectionHandlesToExculde.includes(collectionHandle);
}
// const addManualCollectionSorting = (filter) => {
//   let isJson = false;
//   let isSortJson = false;

//   if (typeof filter === "string") {
//     isJson = true;
//     filter = JSON.parse(filter);
//   }

//   if (typeof filter.sort === "string") {
//     isSortJson = true;
//     filter.sort = JSON.parse(filter.sort);
//   }

//   const newSort = [];

//   // Always prepend these two — but avoid duplicates
//   newSort.push(
//     {
//       field: "product_wizzy-best-selling_sortOrder:float",
//       order: "asc",
//       isForParent: "true",
//       isForVariation: "false",
//     },
//     {
//       field: "product_ksa:float",
//       order: "desc",
//     }
//   );

//   // Add the rest (skipping duplicates)
//   filter.sort.forEach((x) => {
//     if (
//       x.field !== "product_ksa:float" &&
//       x.field !== "product_wizzy-best-selling_sortOrder:float"
//     ) {
//       newSort.push(x);
//     }
//   });

//   filter.sort = newSort;

//   if (isSortJson) filter.sort = JSON.stringify(filter.sort);
//   if (isJson) filter = JSON.stringify(filter);

//   // return filter;
// };

const addManualCollectionSorting = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  if (filter.sort[0].field === "relevance") {
    newSort.push(
      {
        field: "product_wizzy-best-selling_sortOrder:float",
        order: "asc",
        isForParent: "true",
        isForVariation: "false",
      },
      {
        field: "product_ksa:float",
        order: "desc",
      },
      
    );
    filter.sort.forEach((x) => {
      if (
        x.field != "product_ksa:float" &&
        x.field != "product_wizzy-best-selling_sortOrder:float"
      ) {
        newSort.push(x);
      }
    });
  } else {
    //else make sure that selected sort is applying
    newSort = filter.sort;
  }
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }


};
const addCollectionSorting = (filter) => {
      let isJson = false;
      let isSortJson = false;
      if (typeof filter == "string") {
        isJson = true;
        filter = JSON.parse(filter);
      }
      if (typeof filter.sort == "string") {
        isSortJson = true;
        filter.sort = JSON.parse(filter.sort);
      }
      let newSort = [];
      //when sort is relevance than update sort as per requierment
      if (filter.sort[0].field === "relevance") {
        newSort.push(
          {
            field: "product_value_tags_noor_ruled_based_bt:float",
            order: "desc",
          },
          {
            field: "product_ksa:float",
            order: "desc",
          },
          {
            field: "product_wizzy-best-selling_sortOrder:float",
            order: "asc",
            isForParent: "true",
            isForVariation: "false",
          }
          
        );
        filter.sort.forEach((x) => {
          if (
            x.field != "product_ksa:float" &&
            x.field != "product_wizzy-best-selling_sortOrder:float"
          ) {
            newSort.push(x);
          }
        });
      } else {
        //else make sure that selected sort is applying
        newSort = filter.sort;
      }
      filter.sort = newSort;
      if (isSortJson) {
        filter.sort = JSON.stringify(filter.sort);
      }
      if (isJson) {
        filter = JSON.stringify(filter);
      }
    };




const addManualSortingForBFSCollection = (filter) => {
  let isJson = false;
  let isSortJson = false;
  if (typeof filter == "string") {
    isJson = true;
    filter = JSON.parse(filter);
  }
  if (typeof filter.sort == "string") {
    isSortJson = true;
    filter.sort = JSON.parse(filter.sort);
  }
  let newSort = [];
  //when sort is relevance than update sort as per requierment
  if (filter.sort[0].field === "relevance") {
    newSort.push(
      {
        field: "product_ksa:float",
        order: "desc",
      },
      {
        field: "product_value_tags_bracelet_ruled_based_bt:float",
        order: "asc",
        isForParent: "true",
        isForVariation: "false",
      },
      {
        field: "product_value_tags_earring_ruled_based_bt:float",
        order: "asc",
        isForParent: "true",
        isForVariation: "false",
      },
      {
        field: "product_value_tags_rakhi_ruled_based_bt:float",
        order: "asc",
        isForParent: "true",
        isForVariation: "false",
      },
    );
    filter.sort.forEach((x) => {
      if (
        x.field != "product_ksa:float" &&
        x.field != "product_value_tags_bracelet_ruled_based_bt:float" &&
        x.field != "product_value_tags_earring_ruled_based_bt:float" &&
        x.field != "product_value_tags_rakhi_ruled_based_bt:float"
      ) {
        newSort.push(x);
      }
    });
  } else {
    //else make sure that selected sort is applying
    newSort = filter.sort;
  }
  filter.sort = newSort;
  if (isSortJson) {
    filter.sort = JSON.stringify(filter.sort);
  }
  if (isJson) {
    filter = JSON.stringify(filter);
  }
};

// Market Implementation - 09-07-2026
const countryData = {
  UnitedStates: {
    regionCode: "US",
    marketId: 12644352256,
  },
  India: {
    regionCode: "IN",
    marketId: 832897280,
  },
  UnitedArabEmirates: {
    regionCode: "AE",
    marketId: 41824944384,
  },
  UnitedKingdom: {
    regionCode: "GB",
    marketId: 41824780544,
  },
};

function getMarketInventorySource() {
  const detectedCode = window.Shopify?.country || "IN";

  let marketId = countryData.India.marketId; // default fallback

  if (detectedCode) {
    const matchedCountry = Object.values(countryData).find(
      (country) => country.regionCode === detectedCode
    );

    if (matchedCountry) {
      marketId = matchedCountry.marketId;
    }
  }

  if(window.wizzyConfig.common.isOnCategoryPage && window.wizzyConfig.common.collectionHandle === "new-in-ikat")
  {
    return [
      {
        key: String(marketId),
        inStock: [true, false],
      },
    ];
  }

  return [
    {
      key: String(marketId),
      inStock: [true],
    },
  ];
}

const getFloatVal =
  typeof window !== "undefined" && typeof window.getFloatVal === "function"
    ? window.getFloatVal
    : function (value) {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
      };
